import { makeOptionsDataWithEmpty } from 'Common/FormHelper';

export const WEIGHT_UNITS = {
  LB: 'LB',
  GRAMS: 'GRAMS',
  OZ: 'OZ',
};

export const BASE_WEIGHT_UNITS = [
  WEIGHT_UNITS.LB,
  WEIGHT_UNITS.GRAMS,
  WEIGHT_UNITS.OZ,
];

export const VOLUME_UNITS = {
  GALLON: 'GALLON',
  QUART: 'QUART',
  LITER: 'LITER',
  PINT: 'PINT',
  CUP: 'CUP',
  ML: 'ML',
  TSP: 'TSP',
  TEASPOON: 'TEASPOON',
  TBSP: 'TBSP',
  TABLESPOON: 'TABLESPOON',
  'FL OZ': 'FL OZ',
};

export const BASE_VOLUME_UNITS = [
  VOLUME_UNITS.GALLON,
  VOLUME_UNITS.QUART,
  VOLUME_UNITS.LITER,
  VOLUME_UNITS.PINT,
  VOLUME_UNITS.CUP,
  VOLUME_UNITS.ML,
  VOLUME_UNITS.TSP,
  VOLUME_UNITS.TEASPOON,
  VOLUME_UNITS.TBSP,
  VOLUME_UNITS.TABLESPOON,
  VOLUME_UNITS['FL OZ'],
];

export const WEIGHT_UNIT_OPTIONS = makeOptionsDataWithEmpty([
  {
    Id: 'GRAMS',
    Description: 'GRAMS',
  },
  {
    Id: 'OZ',
    Description: 'OZ',
  },
  {
    Id: 'LB',
    Description: 'LB',
  },
]);

export const USDA_SOURCES = {
  USDA: 'USDA',
  FoodIndustry: 'Food Industry',
  Commodity: 'Commodity',
};

export const GRAMS_IN_LBS = 453.59237;

export const GRAMS_IN_OZ = 28.34952;

export const SUBMIT_REPLACE_DEFAULT_ERROR =
  'Cannot Relace Ingredient from one or more Recipes \n\n See Remove/Replace Ingredient Results report for details';

export const SUBMIT_REMOVE_DEFAULT_ERROR =
  'An error occurred while removing the ingredient from the selected recipes.';

export const FETCH_REMOVE_REPLACE_RECIPES_DEFAULT_ERROR =
  'An error occurred while fetching recipe data.';



// WEBPACK FOOTER //
// ./src/pages/manageingredient/helpers/Constants.js